import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import StatusMaintenanceItemsCarousel from "../AddMaintenanceSchedule/MiniComponents/StatusMaintenanceItemsCarousel/StatusMaintenanceItemsCarousel";
import { getAllStandardMaintenanceItems } from "../../../redux/StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";
import { getAllUsers } from "../../../redux/userSlice/userSlice";
import { useParams } from "react-router-dom";
import { getContractById } from "../../../redux/contractSlice/contractSlice";
import { createBulkMaintenanceItem } from "../../../redux/MaintenanceItemSlice/MaintenanceItemSlice";
import AddMaintenanceItem from "../AddMaintenanceItem/AddMaintenanceItem";
import AddMaintenanceItemToSchadules from "../../Inputs/AddMaintenanceItemToSchadules/AddMaintenanceItemToSchadules";

export default function AddMaintenanceItemContract() {
  return (
    <div className="main addContract">
      <h1 className="text-white">اضافة عناصر للجدول</h1>
      <div className="card mt-5">
        <AddMaintenanceItemToSchadules />
      </div>
    </div>
  );
}
